var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11v10c0 .495.481 1 .994 1S17 21.495 17 21V11h4.167C23.05 11 24 12.04 24 14.075v9.862C24 25.972 23.054 27 21.17 27H10.83C8.946 27 8 25.972 8 23.937v-9.862C8 12.04 8.95 11 10.833 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.303 3.307c.238-.236.453-.307.691-.307.25 0 .453.07.692.307l4.028 3.843c.179.177.286.378.286.625 0 .484-.357.826-.858.826a.9.9 0 0 1-.656-.283l-1.811-1.899-.81-.837L17 8v3h-2V8l.124-2.418-2.61 2.736a.874.874 0 0 1-.644.283c-.5 0-.87-.342-.87-.826 0-.247.095-.448.286-.625z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.87633d1cf269acd3edb61eeb9035934b.svg";
export { ForwardRef as ReactComponent };